import { buttonVariants } from '@playcastdotio/Shadcn';
import { Link } from 'react-router-dom';
import { cn } from '../../cssUtility/base';
import config from '../../config.json';

export const Community = () => {
  return (
    <div className='w-full h-auto m-0 p-0 bg-content text-content-text'>
      <div className='container w-full h-auto mx-auto py-20'>
        <section id='community' className='flex flex-col text-center gap-y-4 px-4'>
          <h2 className='font-bold text-3xl'>Join the Community</h2>
          <p className='lg:px-56'>
            Join the growing group of Playcasters on Discord to chat with other streamers, the team building the apps, and report bugs you
            find so we can fix them as soon as possible. And those of you interested in becoming a UX Tester can join that channel to be
            sent surveys, prototypes, and other previews of stuff we're working on.
          </p>
          <div className='flex flex-col md:flex-row gap-2 w-full justify-center'>
            <Link to={config.DISCORD_URL} className={cn(buttonVariants(), 'rounded-full')}>
              Join our Discord
            </Link>
            <Link to='/ux-testers' className={cn(buttonVariants({ variant: 'outline' }), 'rounded-full')}>
              Become a UX Tester
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};
